import * as React from "react";

const { Component } = React;

import { createOrSaveIntegration } from "../IntegrationStore";
import { alert } from "../../general/alertStore.js";
import IntegrationTrigger from "../IntegrationTrigger";
import axios from "../../general/HttpClient";
import { GetContext, UnsubscribeContext } from "../../general/ApplicationContext";
import { ScadsysProps, ScadsysGroupState, ScadsysIntegration } from "./ScadsysStore";
import { Input, FormGroup, Label } from "../../components/Modal";

let contextSubscriptionId = "";

export default class ImportScadsysGroups extends Component<ScadsysProps, ScadsysGroupState> {
    constructor(props) {
        super(props);

        this.state = {
            profiles: [],
            groups: [],
            groupMemberships: [],
            selectedProfile: new ScadsysIntegration(),
            selectedProfileId: "",
            totals: {
                groups: 0,
                memberships: 0,
            },
        };
    }

    saveProfile = () => {
        if (this.state.selectedProfile.name) {
            this.setState(
                (prevState) => {
                    prevState.selectedProfile.integrationDirection = 0; //In
                    prevState.selectedProfile.integrationType = 7; //ScadsysGroups
                    prevState.selectedProfile.organizationId = this.props.organization;

                    return prevState;
                },
                () => {
                    createOrSaveIntegration(this.state.selectedProfile).then(() => {
                        this.getProfiles();
                    });
                }
            );
        }
    };

    loadGroups = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/GetScadsysGroups`, this.state.selectedProfile.config).then((response) => {
            this.setState({
                totals: {
                    groups: response.data.groupResult.totalGroups,
                    memberships: response.data.groupMembershipsResult.totalMemberships,
                },
                groups: response.data.groupResult.groups.map((group) => {
                    group.members = response.data.groupMembershipsResult.memberships.filter((m) => m.groupID == group.id).length;
                    return group;
                }),
                groupMemberships: response.data.groupMembershipsResult.memberships.map((groupMembership) => {
                    return groupMembership;
                }),
            });
        });
    };

    importGroups = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/ImportGroupsFromScadsys`, this.state.selectedProfile.config).then((response) => {
            alert({
                type: "alert-success",
                text: `${response.data.groupsTotal} groups and ${response.data.groupMembershipsTotal} memberships processed successfully`,
            });
        });
    };

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.getProfiles();
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    getProfiles = () => {
        axios
            .get(`/api/Integrations/Types/7?organizationId=${this.props.organization}`) //ScadsysGroups
            .then((response) => {
                this.setState({ profiles: response.data.filter(i=>i.integrationDirection == 0), selectedProfile: new ScadsysIntegration(), selectedProfileId: "" });
            });
    };

    handleProfileChange = (e) => {
        let id = e.target.value;
        this.setState((prevState) => ({ selectedProfileId: id, selectedProfile: new ScadsysIntegration(prevState.profiles.filter((profile) => profile.integrationId == id)[0]) }));
    };

    handleNameChange = (e) => {
        let name = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.name = name;
            return prevState;
        });
    };

    handlePriorityChange = (e) => {
        let priority = e.target.valueAsNumber;
        this.setState((prevState) => {
            prevState.selectedProfile.priority = priority;
            return prevState;
        });
    };

    handleSchoolIdChange = (e) => {
        let schoolId = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.schoolId = schoolId;
            return prevState;
        });
    };

    handleScadsysUrlChange = (e) => {
        let url = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.url = url;
            return prevState;
        });
    };

    handlePageSizeChange = (e) => {
        let pageSize = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.pageSize = pageSize;
            return prevState;
        });
    };

    render() {
        return (
            <div className="space-y-6">
                <h3 className="text-2xl font-semibold text-gray-900">Scadsys Groups Import</h3>

                <div className="space-y-6">
                    <FormGroup>
                        <Label htmlFor="profile">Profile</Label>
                        <Input type="select" id="profile" onChange={this.handleProfileChange} value={this.state.selectedProfileId}>
                            <option>Please Select</option>
                            {this.state.profiles.map((profile) => (
                                <option key={profile.integrationId} value={profile.integrationId}>
                                    {profile.name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>

                    {this.state.selectedProfileId && (
                        <div>
                            <IntegrationTrigger integration={this.state.selectedProfile}></IntegrationTrigger>
                        </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <FormGroup>
                            <Label htmlFor="profileName">Profile Name</Label>
                            <Input type="text" id="profileName" value={this.state.selectedProfile.name} onChange={this.handleNameChange} />
                        </FormGroup>

                        {this.state.selectedProfileId && (
                            <FormGroup>
                                <Label htmlFor="priority">Priority (lower first)</Label>
                                <Input type="number" id="priority" value={this.state.selectedProfile.priority} onChange={this.handlePriorityChange} />
                            </FormGroup>
                        )}

                        {!this.state.selectedProfileId && (
                            <div className="flex items-end justify-end">
                                <button className="px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.saveProfile}>
                                    Create Profile
                                </button>
                            </div>
                        )}
                    </div>

                    {this.state.selectedProfileId && (
                        <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <FormGroup>
                                    <Label htmlFor="schoolId">School ID</Label>
                                    <Input type="text" id="schoolId" value={this.state.selectedProfile.config.schoolId} onChange={this.handleSchoolIdChange} />
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="scadsysUrl">Scadsys URL</Label>
                                    <Input type="text" id="scadsysUrl" value={this.state.selectedProfile.config.url} onChange={this.handleScadsysUrlChange} />
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="pageSize">Page Size</Label>
                                    <Input type="number" id="pageSize" value={this.state.selectedProfile.config.pageSize} onChange={this.handlePageSizeChange} />
                                    <span className="text-sm text-gray-500 mt-1">Make this 0 for all, or specify a number to improve performance on large data sets</span>
                                </FormGroup>

                                <div className="flex items-end justify-end">
                                    <button className="px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.saveProfile}>
                                        Save Profile
                                    </button>
                                </div>
                            </div>

                            <div className="flex justify-end gap-2">
                                <button className="px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.loadGroups}>
                                    Load
                                </button>
                                <button className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.importGroups}>
                                    Import
                                </button>
                            </div>

                            <div className="overflow-x-auto rounded-lg border border-gray-200">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "15%" }}>Group Code</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "25%" }}>Name</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "25%" }}>Source</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "25%" }}>Members</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        <tr>
                                            <th className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{this.state.totals.groups} Groups</th>
                                            <th></th>
                                        </tr>
                                        {this.state.groups.map((group, i) => (
                                            <tr key={`g${i}`} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{group.sourceID}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{group.name}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{group?.customGroupType?.source}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{group.members}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
